<template>
    <div 
        class="p-2 max-w-xs"
        :class="{'bg-gray-300': !message.mine, 'rounded-r-lg': !message.mine, 'rounded-bl-lg': !message.mine, 'bg-blue-600': message.mine, 'rounded-l-lg': message.mine, 'rounded-br-lg': message.mine, 'text-white': message.mine}">
            <img 
                class="w-full" 
                ref="image"
                :class="{ 'rounded-r-lg': !message.mine, 'rounded-bl-lg': !message.mine, 'rounded-l-lg': message.mine, 'rounded-br-lg': message.mine }" />

            <p class="text-sm">{{ message.text }}</p>
    </div>
</template>

<script setup>

import fire from "./fire"
import { shallowRef, onMounted } from 'vue'
import { getStorage, ref, getDownloadURL } from 'firebase/storage'

const props = defineProps( {
    message: {
        type: Object,
        required: true
    }
} )


const image = shallowRef( null )


onMounted( () => getUri() )


function getUri() {
    const storage = getStorage( fire.app() )
    const imagePathReference = ref( storage, `images/${ props.message.src }` )

    getDownloadURL( imagePathReference )
    .then( url => {
        image.value.src = url
    } )
}

</script>
